import {
  ENUM_VALUE_TYPE,
  STRING_VALUE_TYPE,
  CELL_LAYOUT_TYPE,
} from 'grb-webui/components/FilterBar';
import LicenseSelectHOC from '../LicenseSelect';

export default ({ licenseProp, Component, LicenseSelect, ...options }) => {
  return {
    title: 'License',
    name: licenseProp || 'licenseId',
    type: Component ? ENUM_VALUE_TYPE : STRING_VALUE_TYPE,
    layout: CELL_LAYOUT_TYPE,
    layoutConfig: { column: '1/-1' },
    Component: Component || LicenseSelect || LicenseSelectHOC(options),
    namedValues: [
      { value: undefined, label: 'All licenses' },
    ],
    getValueLabel(value) {
      if (value === undefined) return 'All licenses';
      return `License ${value}`;
    },
    createObjectFilter: (license) => {
      return (o) => {
        const l = o[licenseProp || 'licenseId'];
        return l && (l.indexOf(license) >= 0);
      };
    },
    validateValue: (license, { licensesById, allLicenses, licenses }) => {
      if (licensesById && licensesById[license]) {
        return license;
      }
      if (!allLicenses && !licenses) {
        return license;
      }
      const l = (allLicenses || licenses).find(x => !x.invalid);
      return l && l.id;
    },
  };
};
